<template>
	<div class="stationMap" style="height: 100%;width: 100%;" id="stationMap">
		<SearchCity @selectCity="getCityPoint"></SearchCity>
		<div id="PTechart" class="pieClass"></div>
	</div>
</template>

<script>
	// import gaodeMap from "../../../js/GaodeMapMethod.js"
	import echart from '../../../js/echarts_hot.js';
	import SearchCity from "./Template/SearchCity.vue"
	import webapi from '../../../webapi.js';
	export default {
		data() {
			return {
				map: null,
				features: [],
				pieMap1: {
					totalNum: 0,
					series: [{
							value: 2,
							name: "空闲"
						}, {
							value: 3,
							name: "充电"
						},
						{
							value: 5,
							name: "离线"
						},
						{
							value: 1,
							name: "故障"
						}
					],
					legend_data: ["空闲", "充电", "离线", "故障"]
				},
			}
		},
		deactivated() {
			this.$destroy();
		},
		destroyed() {
			echart.disposeEchart(null)
		},
		components: {
			SearchCity: SearchCity
		},
		mounted() {
			// gaodeMap.initMap("stationMap", 10, null, 'normal');
			this.GetOverviewStations();
			//gaodeMap.createMarkeList(this.features)
		},
		methods: {
			// getCityPoint: function(cityName) {
			// 	gaodeMap.geoCode(cityName).then(res => {
			// 		gaodeMap.map.setCenter(res)
			// 	})
			// },
			//地图数据
			GetOverviewStations: function() {
				const _this = this;
				_this.$axios.post(webapi.base_api_url + "/Overview/GetOverviewStations", ).then(res => {
					if (res.data.code != 1) {
						console.log(res.data);
						let WorkingNum = 0;
						let StandbyNum = 0;
						let BreakdownNum = 0;
						let OfflineNum = 0;
						res.data.Data.List.forEach(function(item, index, ary) {
							const featuresItem = {
								position: [item.Longitude, item.Latitude],
								type: item.BreakdownNum == 0 ? 'free' : 'fault',
								StationId: item.StationId,
								StationInfo: item
							}
							WorkingNum = WorkingNum + item.WorkingNum;
							StandbyNum = StandbyNum + item.StandbyNum;
							BreakdownNum = BreakdownNum + item.BreakdownNum;
							OfflineNum = OfflineNum + item.OfflineNum;
							_this.features.push(featuresItem);
							//console.log(featuresItem)
						})
						// gaodeMap.createMarkeList(this.features);
						let pieSeries = [{
								value: StandbyNum,
								name: "空闲"
							}, {
								value: WorkingNum,
								name: "充电"
							},
							{
								value: OfflineNum,
								name: "离线"
							},
							{
								value: BreakdownNum,
								name: "故障"
							}
						];
						let totalNum = WorkingNum + StandbyNum + OfflineNum + BreakdownNum;
						const pieSeriesData = {
							pieSeries: pieSeries,
							totalNum: totalNum
						}
						this.pieEchart(pieSeriesData)
					}
				})
			},
			pieEchart: function(params) {
				this.pieMap1.series = params.pieSeries
				this.pieMap1.totalNum = params.totalNum
				echart.disposeEchart("PTechart")
				echart.initPiechart("PTechart", this.pieMap1, this);
			}
		}
	}
</script>

<style>
	.infoMessageStyle {
		background-color: #cccccc;
		background-image: linear-gradient(#cccccc, #ffffff);
		opacity: 1;
		width: 15.625rem;
	}

	/* .stationMap{  padding-top:10px; width:100%;text-align: center;} */
	.stationMap table {
		border-collapse: collapse;
		border: 1px solid #00a0e9;
		color: #000000;
		width: 100%
	}

	.stationMap td {
		border-collapse: collapse;
		border: 1px solid #00a0e9;
		padding: 2px 4px;
	}

	.stationMap td.green {
		color: #05d60f;
		text-align: left
	}

	.stationMap td.orange {
		color: #d75a07;
		text-align: left
	}

	.numberDisplay4 p {
		display: block;
		border-left: 4px solid green;
		padding-left: 2px;
		text-align: left;
		font-size: 10px;
	}

	.numberDisplay4 td {
		width: 20%;
	}

	.numberDisplay4 span {
		font-size: 15px;
		font-weight: bold;
		text-align: left;
		color: #282c35;
	}

	.pieClass {
		width: 350px;
		height: 200px;
		position: absolute;
		z-index: 1;
		bottom: 10px;
		right: 10px;
		background-image: linear-gradient(#676767, #949494);
	}
</style>
